import { NotFound, useDynamicConfig } from "@dgs/core";
import { Navigate, Route, Routes } from "react-router";
import { CreateEventProvider } from "../../../shared/events/save/CreateEventProvider";
import { FilterProvider } from "../../../shared/filters";
import { eventService } from "../shared/api/event/eventService";
import { CreateEventPage } from "./CreateEventPage";
import { DuplicateEventPage } from "./DuplicateEventPage";
import { ActiveEventPage, ArchivedEventPage } from "./EventPage";
import { EventsOverview } from "./overview/EventsOverview";
import { EventUserRequestPage } from "./requests/EventUserRequestPage";

export const AdminEventsPage = () => {
	const { defaultCurrency } = useDynamicConfig();

	return (
		<CreateEventProvider defaultCurrency={defaultCurrency}>
			<FilterProvider entity="EVENT" keysToInvalidate={[eventService.indexKey]}>
				<Routes>
					<Route index={true} element={<Navigate to="active" replace={true} />} />
					<Route path="active/*" element={<ActiveEventPage />} />
					<Route path="archived/*" element={<ArchivedEventPage />} />
					<Route path="overview/*" element={<EventsOverview />} />
					<Route path="requests/*" element={<EventUserRequestPage />} />
					<Route path="create/*" element={<CreateEventPage />} />
					<Route path="create/from-event/:eventId/*" element={<DuplicateEventPage />} />
					<Route path="*" element={<NotFound />} />
				</Routes>
			</FilterProvider>
		</CreateEventProvider>
	);
};
